import { StoreRootState } from '@/store';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Outlet, useNavigate, useParams } from 'react-router-dom';

const IsAlreadyRegister = () => {
	const navigate = useNavigate();
	const params = useParams();
	const { attendee, eventId } = useSelector((state: StoreRootState) => state.registration);
	useEffect(() => {
		if (attendee && eventId === params.eventId) navigate(`/events/${eventId}/qr/${attendee.id}`);
	}, [attendee]);
	return <Outlet />;
};

export default IsAlreadyRegister;
